import { useTranslation } from 'react-i18next';

import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  FormBanner,
  toast,
} from '@saas-kit/ui';

interface Props {
  secret: string;
  onDismiss: () => void;
}

export function ApiKeySecretCard({ secret, onDismiss }: Props): JSX.Element {
  const { t } = useTranslation('apiKeys');

  const onCopy = async (): Promise<void> => {
    if (!navigator.clipboard) {
      toast.error(t('toasts.copy_unavailable'));
      return;
    }
    await navigator.clipboard.writeText(secret);
    toast.success(t('toasts.copied'));
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('secret.title')}</CardTitle>
        <CardDescription>{t('secret.description')}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <FormBanner variant="info">{t('secret.banner')}</FormBanner>
        <div className="rounded-lg border border-border bg-muted/30 p-4">
          <p className="text-xs uppercase tracking-wide text-muted-foreground">
            {t('secret.label')}
          </p>
          <p className="mt-2 break-all font-mono text-sm text-foreground">
            {secret}
          </p>
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onDismiss}>
            {t('secret.dismiss')}
          </Button>
          <Button variant="secondary" onClick={() => void onCopy()}>
            {t('secret.copy')}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
